<template>
    <div>
        <!-- <mt-field :label="label" :readonly="readonly" :value="selectedDisplayValue" v-if="readonly" :titlewidth="titlewidth" :value-align="textalign">
        </mt-field> -->
        <mt-cell :title="label" :readonly="readonly" v-if="readonly" :titlewidth="titlewidth" :value-align="textalign" >
            <div class="em-select-value mt-color-grey-lv3">
                <template>{{selectedDisplayValue}}</template>
            </div>
        </mt-cell>
        <mt-cell :title="label" is-link v-if="!readonly" :disabledcolor="disabled" :required="required" @click.native="handleDisplayClick" :titlewidth="titlewidth" :value-align="textalign">
            <span style="lineHeight:initial" :class="[{'mt-color-grey-lv3':selectedDisplayValue ==='请选择','aabb':true}]">{{selectedDisplayValue}}</span>
        </mt-cell>
        <bs-transition-page v-if="!readonly" v-model="selectorShow">
            <!-- <div style="padding: 12px 20px; background-color: rgb(255, 255, 255); font-size: 17px;">
                <span style="float:left;" @click.native="goback">退回</span>
            </div> -->
            <mt-search v-model="searchKey" placeholder="请输入关键字" v-if="search"></mt-search>
            <!-- select 模板 -->
            <template v-if="selectType === 'select'">
                <mt-box-group v-model="currentValue" :style="{overflow: 'auto', height:radiolistHeight+'px'}">
                    <mt-cell-group>
                        <div v-infinite-scroll="loadMore" infinite-scroll-disabled="false" infinite-scroll-distance="10">
                            <mt-radiobox :name="item.value" :disabled="item.disabled" :key="item.value" v-for="item in selectOptions" @change.native="handleClickSelect">{{item.label}}</mt-radiobox>
                        </div>
                    </mt-cell-group>
                </mt-box-group>
                <div style="width:100%;">
                    <mt-button class="" size="large" type="default" @click="goback">返回</mt-button>
                </div>
            </template>
            <!-- multi-select 模板 -->
            <template v-else-if="selectType === 'multi-select'">
                <mt-box-group v-model="currentValue" :style="{overflow: 'auto', height:checklistHeight+'px'}">
                    <mt-cell-group>
                        <div v-infinite-scroll="loadMore" infinite-scroll-disabled="false" infinite-scroll-distance="footerHeight + 10">
                            <mt-checkbox :name="item.value" :disabled="item.disabled" :key="item.value" v-for="item in selectOptions">
                                {{item.label}}
                            </mt-checkbox>
                        </div>
                    </mt-cell-group>
                </mt-box-group>
                <base-selected-footer :options="options" v-model="currentValue" @confirm-click="handleConfirm"></base-selected-footer>
            </template>
        </bs-transition-page>
    </div>
</template>
<script>
import baseSelectedFooter from './baseSelectorFooter.vue';
import bsTransitionPage from '../bsTransitionPage.vue';
const pageSize = 20;
export default {

    name: 'baseSelect',

    props: {
        search: { default: true },
        readonly: { default: false },
        disabled: { default: false },
        required: { default: false },
        displayValue: { default: '' },
        value: { default: '' },
        /**
         * @noteType prop
         * @field label
         * @desc 标题
         * @type input
         * @value 标题
         */
        label: { type: String, required: true },
        /**
         * @noteType prop
         * @field placeholder
         * @desc 占位文本
         * @type input
         * @value 请选择
         */
        placeholder: { type: String, default: '请选择' },
        options: {
            default: function() {
                return [];
            }
        },
        /**
         * @noteType prop
         * @field selectType
         * @desc 选择器类型
         * @type multi-select ,select
         */
        selectType: { type: String, default: 'select' },
        titlewidth:{
            type: String,
            default: function() {
                return '';
            }
        },
        textalign:{
            type: String,
            default: function() {
                return '';//flex-start
            }
        }

    },

    data() {
        return {
            searchKey: '',
            selectorShow: false,
            cHeight: document.documentElement.clientHeight,
            footerHeight: 59,
            searchHeight: 44,
            currentValue: this.getCurrentValue(this.value, this.selectType),
            start: 1,
            preHandler:{}
        };
    },
    created(){
        //debugger
        console.log(this)
    },
    computed: {
        checklistHeight() {
            if (this.search) {
                return this.cHeight - this.footerHeight - this.searchHeight;
            }
            return this.cHeight - this.footerHeight;
        },
        radiolistHeight() {
            var visibleHeight = '';
            if (this.search) {
                visibleHeight = this.cHeight - this.searchHeight - 44;
            }else {
                visibleHeight = this.cHeight - 44;
            }
            var contentHeight = (this.selectOptions && this.selectOptions.length>0)?this.selectOptions.length * 50:10000;//50是标准单个cell的高度
            return (visibleHeight > contentHeight)?contentHeight:visibleHeight;
        },
        convertedOptions() {
            return this.getSelectOptions(this.options);
        },
        selectOptions() {
            if (this.searchKey) {
                return this.convertedOptions.filter((item) => {
                    return item.label.indexOf(this.searchKey) > -1;
                }).slice(0, this.start * pageSize);
            }
            return this.convertedOptions.slice(0, this.start * pageSize);
        },
        selectedDisplayValue() {
            let currentValue = this.value;
            if (currentValue) {
                if (!this.options.length) {
                    return this.displayValue;
                }
                let displays = [];
                let vals = currentValue.split(',');
                this.options.forEach((item) => {
                    vals.forEach(function(v) {
                        if (v === item.id) {
                            displays.push(item.name);
                        }
                    });
                });
                return displays.join(',') || this.displayValue;
            }
            if (!this.readonly) {
                return this.placeholder;
            }
            return this.displayValue;
        }
    },

    watch: {
        value(val) {
            if (!this._isValueEqual()) {
                this.currentValue = this.getCurrentValue(val, this.selectType);
            }
            this.$emit('display-change', this.selectedDisplayValue);
        },
        currentValue(val) {
            //移除禁止滑动事件
            //document.removeEventListener('touchmove', this.preHandler, false);
            if (this.selectType === 'select') {
                this.$emit('input', (val || '').toString());
            }
            $('body').removeClass('vf-h');
            $('#app').removeClass('vf-h');
        },
        selectorShow(val) {
            this.preHandler = function(e){e.preventDefault();}
            if (val) {
                // if(localStorage.getItem('cHeight')){
                //     this.cHeight = localStorage.getItem('cHeight')
                // }else {
                //     this.cHeight = document.documentElement.clientHeight;
                //     localStorage.setItem('cHeight',this.cHeight)
                // }
                //添加禁止滑动事件
                //document.addEventListener('touchmove', this.preHandler, false);
                $('body').addClass('vf-h');
                $('#app').addClass('vf-h');  
            } else {
                //移除禁止滑动事件
                //document.removeEventListener('touchmove', this.preHandler, false);
                if (!this._isValueEqual()) {
                    //如果用户没有点击确定，重置勾选状态
                    this.currentValue = this.getCurrentValue(this.value, this.selectType);
                }
            }
        },
        options() {
            this.start = 1;
        }
    },

    mounted() {
        window.addEventListener('resize', this.getCHeight);
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.getCHeight);
    },

    methods: {
        getCHeight() {
            this.cHeight = document.documentElement.clientHeight;
        },
        goback() {
            //移除禁止滑动事件
            // document.removeEventListener('touchmove', this.preHandler, false);
            $('body').removeClass('vf-h');
            $('#app').removeClass('vf-h');
            history.go(-1);
        },
        _isValueEqual() {
            if (this.selectType === 'select') {
                return this.value === this.currentValue;
            }
            return this.value === this.currentValue.join(',');
        },
        getCurrentValue(val) {
            if (this.selectType === 'select') {
                return val;
            } else {
                if (!val) { return []; }
                return val.split(',');
            }
        },
        getSelectOptions(options) {
            if (options && options.length) {
                return options.map((item) => {
                    return {
                        value: item.id,
                        label: item.name
                    };
                });
            }
            return [];
        },
        handleDisplayClick() {
            if (this.readonly || this.disabled) {
                return;
            }
            this.selectorShow = true;
        },
        handleClickSelect() {
            history.back();
        },
        handleConfirm() {
            this.$emit('input', this.currentValue.join(','));
            history.back();
        },
        loadMore() {
            if (Math.ceil(this.options.length / pageSize) >= (this.start + 1)) {
                this.start++;
            }
        }
    },

    components: {
        baseSelectedFooter,
        bsTransitionPage
    }
};
</script>
<style lang="css" scoped>
.selector-pick-container .mint-box-group .mint-cell-group .mint-cell-group-content .mint-cell:first-child .mint-cell-wrapper{
    border-top:none;
}
</style>
<style>
.vf-h {
    overflow: hidden !important;
}
</style>


// WEBPACK FOOTER //
// baseSelect.vue?41be9b42